import styled from '@emotion/styled';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import { webPalette } from 'src/themes';

interface StyledTextFieldProps {
  size?: 'small' | 'medium';
}

const StyledTextField = styled(MuiTextField)<StyledTextFieldProps>(
  ({ theme: { palette }, size }) => `
  input {
    padding: ${size === 'small' ? '0.3rem' : '0.8rem'};

    &:disabled {
      color: ${palette.grey[600]} !important;
      -webkit-text-fill-color: inherit;
    }
  }

  label {
    color: ${palette.grey[300]};
    opacity: 0.85;

    &:active {
      color: ${palette.text.primary} !important;
      opacity: 1;
    }
  }

  fieldset {
    border-radius: 8px;
    border: 1px solid ${palette.text.primary};
  }

  input:disabled ~ svg {
    color: ${webPalette.layoutUserPopover};
  }

  input:disabled ~ fieldset {
    border-color: ${webPalette.layoutUserPopover} !important;
  }

  .Mui-disabled {
    color: ${palette.grey[300]} !important;
   
    div {
      color: ${palette.grey[600]};
      -webkit-text-fill-color: ${palette.grey[600]};
    }
  }
`
);

export const TextField = ({ placeholder, hiddenLabel, label, size, inputProps, ...props }: TextFieldProps) => {
  return (
    <StyledTextField
      size={size}
      margin='dense'
      placeholder={placeholder}
      label={hiddenLabel ? null : placeholder || label}
      fullWidth
      inputProps={{ maxLength: 255, ...inputProps }}
      {...props}
    />
  );
};

// Sometimes its hard to override custom styles already provided to component above (which is
// used in most of the cases), so by exporting default mui TextField we just make it easy again
export const DefaultMuiTextField = MuiTextField;
